import { render } from "./HeroiconsSolidMenu.vue?vue&type=template&id=15543d3b"
const script = {}

import exportComponent from "/home/nginx/domains/panel.vip-mod.net/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidMenu.vue"]])

export default __exports__